exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.projects-tasks{height:100%;border:1px solid #8b8b8b;overflow:hidden;overflow-y:auto}.projects-tasks .empty-tasks{display:flex;align-items:center;flex-direction:column;justify-content:center;height:68%;width:100vw}.projects-tasks .empty-tasks__image{width:33%;margin-left:3%}.projects-tasks .empty-tasks__description{margin:0;margin-top:18px;margin-left:30px;margin-right:30px}.projects-tasks .empty-tasks__description,.projects-tasks .empty-tasks__description2{color:#9b9b9b;font-family:Open Sans,sans-serif;font-size:16px;text-align:center;padding:0}.projects-tasks .empty-tasks__description2{margin:0;margin-left:30px;margin-right:30px}.projects-tasks .empty-tasks__indicator{margin-bottom:-3px}.projects-tasks .offline-no-tasks{display:flex;align-items:center;flex-direction:column;justify-content:center;height:100%;width:100vw}.projects-tasks .offline-no-tasks__image{width:33%;margin-left:3%}.projects-tasks .offline-no-tasks__description{color:#9b9b9b;font-family:Open Sans,sans-serif;font-size:24px;margin-top:32px;font-weight:600;text-align:center}.projects-tasks .loading-dots-cont{position:fixed;bottom:0;display:flex;justify-content:center;width:100%}@media only screen and (min-device-width:320px) and (max-device-width:480px){.projects-tasks{border:none;box-shadow:none;width:100%;border-radius:0;overflow-y:scroll;-webkit-overflow-scrolling:touch}}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/TasksContainer/NewProjectsTasksContainer/ProjectsTasksContainer.scss
// module id = 1852
// module chunks = 0